// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeIdentityMethodsGetBody = {};

export type typeIdentityMethodsGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    email: { isLinked: boolean; address?: string | null };
    apple: { isLinked: boolean; linkedAt?: string | null };
    google: { isLinked: boolean; linkedAt?: string | null };
  };
};

export type typeIdentityMethodsGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeIdentityMethodsGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeIdentityMethodsGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaIdentityMethodsGetBody = {
  type: "object",
  properties: {},
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createIdentityMethodsGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaIdentityMethodsGetBody);
  }

  return async function postIdentityMethodsGet(
    payload: typeIdentityMethodsGetBody,
  ): Promise<
    typeIdentityMethodsGetOutput200 | typeIdentityMethodsGetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postIdentityMethodsGet" failed before calling the network. #f9c250b07ff4`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#f9c250b07ff4" },
        },
        data: null,
      } as typeIdentityMethodsGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/identity/methods-get`,
      httpMethod: "POST",
      options,
    })) as typeIdentityMethodsGetOutput200 | typeIdentityMethodsGetOutput400;
  };
}
